import { render, staticRenderFns } from "./CurrentOrdersHead.vue?vue&type=template&id=0851ea93&scoped=true"
import script from "./CurrentOrdersHead.vue?vue&type=script&lang=js"
export * from "./CurrentOrdersHead.vue?vue&type=script&lang=js"
import style0 from "./CurrentOrdersHead.vue?vue&type=style&index=0&id=0851ea93&prod&scoped=true&lang=scss"
import style1 from "./CurrentOrdersHead.vue?vue&type=style&index=1&id=0851ea93&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851ea93",
  null
  
)

export default component.exports